// extracted by mini-css-extract-plugin
export var completionBody = "_hd-2";
export var completionCard = "_hd-0";
export var completionFooter = "_hd-3";
export var completionTitle = "_hd-1";